module.exports = __webpack_public_path__ + "img/trash_rojo.84a22132.svg";